import { render, staticRenderFns } from "./ListContentEditor.vue?vue&type=template&id=23e1efae&scoped=true"
import script from "./ListContentEditor.vue?vue&type=script&lang=js"
export * from "./ListContentEditor.vue?vue&type=script&lang=js"
import style0 from "./ListContentEditor.vue?vue&type=style&index=0&id=23e1efae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e1efae",
  null
  
)

export default component.exports